var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobeMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#3c3c3c",
    id: "filled",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "globe-map") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35,23H31.7808L30.97,19.7578a.9989.9989,0,0,0-.8462-.75l-12-1.5a.9983.9983,0,0,0-.9326.4043l-4,5.5a.9988.9988,0,0,0-.0488,1.1025l3,5A1.0007,1.0007,0,0,0,17,30h4.1978l1.8261,8.2168A.9994.9994,0,0,0,24,39h4a1,1,0,0,0,.9487-.6836l2.9434-8.831,3.8887-4.86A1,1,0,0,0,35,23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8491,11.15a21,21,0,1,0-22.2,34.4983l.0583.0583.0282-.028a20.7812,20.7812,0,0,0,14.53,0l.0282.028.0583-.0583A20.9581,20.9581,0,0,0,40.8491,11.15ZM33.7429,43.3289,31.707,41.293A1,1,0,0,0,31,41H21a1,1,0,0,0-.707.293l-2.0359,2.0359A18.9864,18.9864,0,0,1,17.2,9.1606l.8079,6.4634a1,1,0,0,0,1.61.6621l6.6533-5.2275,4.8989.8164,1.854,8.3418A.9994.9994,0,0,0,34,21h8a1,1,0,0,0,.97-.7578l.4481-1.7925a18.915,18.915,0,0,1-9.6754,24.8792Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeMap);
export default __webpack_public_path__ + "static/media/globe-map.a151bb023c097fe231216a08b3007c33.svg";
export { ForwardRef as ReactComponent };